export type UnknownRecord = Record<string, unknown>;

/**
 * Единственная копия проверки формы ответа демона — раньше повторялась в
 * семи `*-api.ts` дословно (stage6-acceptance-debts, design.md решение 9).
 */
export function isRecord(value: unknown): value is UnknownRecord {
  return typeof value === "object" && value !== null;
}
